// Material UI
import { makeStyles } from '@material-ui/styles'
// Consts
import Colors from '../../../../constants/Colors'

export default makeStyles(theme => ({
  toppingsContainer: {
    display: 'grid',
    gridAutoFlow: 'row',
    gridAutoRows: 'min-content',
    gridRowGap: 5,
    paddingTop: 5,
  },
  toppingCheckboxRoot: {
    padding: '0px',
  },
  root: {
    borderBottom: `1px solid ${Colors.DISABLED_COLOR}`,
    borderLeft: `3px solid ${Colors.ORDER_PRODUCTS_BORDER_COLOR}`,
    borderRight: `1px solid ${Colors.DISABLED_COLOR}`,
    borderTop: `1px solid ${Colors.DISABLED_COLOR}`,
  },
  toppingGroupContainer: {
    borderLeft: `1px solid ${Colors.DISABLED_COLOR}`,
    padding: '0px 16px 0px 16px',
  },
  toppings: {
    padding: '20px 0px 24px 13px',
  },
  checkboxLine: {
    alignItems: 'center',
    display: 'grid',
    gridTemplateColumns: 'auto min-content',
    justifyContent: 'space-between',
    fontFamily: 'Poppins',
    fontSize: 17,
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 'normal',
    letterSpacing: 'normal',
    lineHeight: 'normal',
  },
  productName: {
    borderBottom: `1px solid ${Colors.DISABLED_COLOR}`,
    padding: '14px 7px 14px 16px',
  },
  text: {},
  groupTitle: {
    fontSize: 13,
    color: Colors.SECONDARY_FONT_COLOR,
    lineHeight: 'normal',
  },
}))
